<template>
  <div class="mobile-container">
    <page-header>{{'大会日程' | dealLanguage('Conference Agenda')}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="main-content">
      <!-- <div class="first-froum" v-if="main_froum.activityId">
        <div class="froum-title">
          <span>{{main_froum['activityName'] | dealLanguage(main_froum['enActivityName'])}}</span>
        </div>
      </div> -->
      <div class="first-froum" v-if="main_froum.activityId">
        <div class="froum-title">
          <span>{{
            '2026CSGCT大会结构'
              | dealLanguage('2026CSGCT Conference Structure')
          }}</span>
        </div>
      </div>
      <div
        class="froum-module"
        v-for="(item, index) in froum_modules"
        :key="index"
      >
        <div class="froum-module-title">
          <span>{{ item.title | dealLanguage(item.enTitle) }}</span>
        </div>
        <div class="froum-list">
          <div class="list-view">
            <div
              class="froum-li"
              v-for="(fItem, fIndex) in froum_list.filter((a) => item.themeIds.includes(a.activityId - 0))"
              :key="fIndex"
            >
              <div class="froum-title">{{ fItem.activityName | dealLanguage(fItem.enActivityName)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { getAgendaList } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('大会日程', 'Conference Agenda'),
    }
  },
  inject: ['globalInsertRecords', 'wxShare'],
  data () {
    return {
      main_froum: {},
      froum_list: [],
      loading: false,
      froum_modules: [
        {
          title: '19日上午',
          enTitle: 'On the morning of the 19th',
          themeIds: [1167, 1041, 1033, 1039, 1036, 1046, 1045, 1134, 1162],
        },
        {
          title: '19日下午',
          enTitle: 'On the afternoon of the 19th',
          themeIds: [1129, 1042, 1034, 1040, 1037, 1047, 1045, 1165],
        },
        {
          title: '20日上午',
          enTitle: 'On the morning of the 20th',
          themeIds: [1032, 1044, 1035, 1038],
        },
        {
          title: '20日下午',
          enTitle: 'On the afternoon of the 20th',
          themeIds: [1133, 1043, 1044, 1035, 1038, 1135, 1166],
        },
      ],
    }
  },

  components: {
    PageHeader
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
    })
  },

  created() {
    this.getAgendaList()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('大会日程-CSGCT', 'Conference Agenda-CSGCT'),
      linkurl: this.vbef_path + '/theme',
    })
  },

  methods: {
    async getAgendaList() {
      this.loading = true
      let res = await getAgendaList({
        actId: this.activityId,
        assortName: '',
        dateName: '',
      })
      this.loading = false
      if (res.code == 0 && res.data.activities.length > 0) {
        this.$set(this.$data, 'main_froum', res.data.activities[0])
        this.$set(this.$data, 'froum_list', res.data.activities)
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.mobile-container
  position relative
  .main-content
    padding .4rem
    .first-froum
      background-image url('~pic/theme-bg.png')
      background-repeat no-repeat
      background-size 100% 100%
      height 1.8rem
      display flex
      align-items center
      cursor pointer
      .froum-title
        width 100%
        height .8rem
        background linear-gradient(90deg, rgba(255, 167, 98, 0.6) 0%, #FF7000 53%, rgba(255, 167, 98, 0.6) 100%)
        padding 0 .4rem
        font-weight 400
        font-size .24rem
        color #FFFFFF
        line-height 1.5
        display flex
        align-items center
        justify-content center
  .froum-module-title
    font-weight 400
    font-size .28rem
    color #C7000C
    line-height .4rem
    padding .16rem .2rem
    display flex
    align-items center
    justify-content center
    background #FFF3F3
    border 1px solid #ED6D01
    border-top none
    border-bottom none
  .froum-list
    border 1px solid #ED6D01
    .list-view
      display grid
      grid-template-columns repeat(2, 1fr)
      margin-bottom -1px
    .froum-li
      padding .2rem
      display flex
      align-items center
      cursor pointer
      transition: all .3s ease-in-out
      border-right 1px solid #ED6D01
      border-bottom 1px solid #ED6D01
      &:nth-child(2n)
        border-right 0
      .froum-title
        width 100%
        font-weight 400
        font-size .24rem
        color #C7000C
        line-height .36rem
        text-align: center
</style>
